/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, Grid, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs } from '@mui/material'
import React, { useEffect } from 'react'
import cssClasses from './Dashboard.module.css'
import totalLeads from '../../Assets/Images/Dashboard/totalLeads.svg'
import activeLeads from '../../Assets/Images/Dashboard/activeLeads.svg'
import totalTokens from '../../Assets/Images/Dashboard/totalTokens.svg'
import totalAllotments from '../../Assets/Images/Dashboard/totalAllotments.svg'
import agreementDone from '../../Assets/Images/Dashboard/agreementDone.svg'
import DashboardCard from '../../Subcomponents/DashboardCard/DashboardCard'
import { cpAnalytics, getAllCounts, getCountsByYearForProject, getCp, getProjects, getTokenDataBySalesTeam, getTokenWiseUnitsSold, getTopCpByProject, getTopFosByCp, getTopProjects, getTopSales, getTopSalesByProject, getTopSalesInEvent, getTopSalesInSustenance, getUniqueUnitTypes, getUnitAnalysis, getdataforcpdoughnut, projectAnalytics } from '../../Services/Dashboard'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../Redux Store/actions'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import DropDown from '../../Subcomponents/DropDown'
import Datagrid from '../../Subcomponents/Datagrid'
import Project from '../Icons/Project'
import User from '../Icons/User'
import { dismissLoader, presentLoader } from '../../Services/loader'
import { TabContext, TabPanel } from '@mui/lab'
import TabsMenu from '../../Subcomponents/TabsMenu'
import { supabase } from '../../supabaseClient'
import { groupBy, orderBy, sortBy, uniqBy } from 'lodash'
import CustomAutoComplete from '../../Subcomponents/CustomAutoComplete'
import TotalTokensAnalysis from './TotalTokensAnalysis'
import EventsDashboard from './EventsDashboard/EventsDashboard'

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, ArcElement);

export default function Dashboard() {
    const dispatch = useDispatch();
    let [allCounts, setAllCounts] = useState(null)
    let [users, setUsers] = useState([])
    let [projectCounts, setProjectCounts] = useState(null)
    let [bookingInProgressCounts, setBookingInProgressCounts] = useState(null)
    let [cpCounts, setCpCounts] = useState(null)
    let [unitCounts, setUnitCounts] = useState(null)
    let [topProjects, setTopProjects] = useState([])
    let [topSalesInEvent, setTopSalesInEvent] = useState([])
    let [selectedProjectForBookingInProgress, setSelectedProjectForBookingInProgress] = useState('')
    let [topSalesInSustenance, setTopSalesInSustenance] = useState([])
    let [tokenWiseUnits, setTokenWiseUnits] = useState([])
    let [projectForUnits, setProjectForUnits] = useState('All')
    let [currentTeamMembers, setCurrentTeamMembers] = useState([])
    let [allTeams, setAllTeams] = useState([])
    let [tokensForSales, setTokensForSales] = useState([])
    let [topFos, setTopFos] = useState([])
    let [allCp, setAllCp] = useState([])
    let [unitSoldData, setUnitSoldData] = useState([])
    let [cpProjectData, setCpProjectData] = useState([])
    let [allProjects, setAllProjects] = useState([])
    let [allEvents, setAllEvents] = useState([])
    let [event, setEvent] = useState(null)
    let [projects, setProjects] = useState([])
    let [team, setTeam] = useState([])
    let [topSales, setTopSales] = useState([])
    let [topCp, setTopCp] = useState([])
    let [selectedGraph, setSelectedGraph] = useState('totalsalesamount')
    let [currentProject, setCurrentProject] = useState('')
    let [currentProjectForAll, setCurrentProjectForAll] = useState('')
    let [currentTeamLead, setCurrentTeamLead] = useState('')
    let [mode, setMode] = useState('all')
    let [currentYear, setCurrentYear] = useState(new Date().getFullYear())
    const yearList = getYears(2023)
    const loggedInUser = useSelector((state) => state.Auth.user);
    const [tabValue, setTabValue] = useState("");
    const [tabs, setTabs] = useState([])
    const [userIds, setUserIds] = useState([])
    const [selectedProject, setSelectedProject] = useState('')
    const [selectedCp, setSelectedCp] = useState([])
    const [subTabs, setSubTabs] = useState([
        {
            text: "Overview",
            value: "Overview",
            isSelected: true,
            key: 0,
        },
        {
            text: "Inventory",
            value: "Inventory",
            isSelected: false,
            key: 0,
        },
        {
            text: "Sales",
            value: "Sales",
            isSelected: false,
            key: 0,
        }
    ])
    // const colors = ['#6366F1', '#4ADE80', '#C7D2FE', '#F87171', '#9333EA', '#F59E0B', '#EF4444','#6366F1', '#4ADE80', '#C7D2FE', '#F87171', '#9333EA', '#F59E0B', '#EF4444']
    const colors = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
    // const projectColumns = [
    //     {
    //         field: "projectname",
    //         headerName: "Name",
    //     },
    //     {
    //         field: "totalsalesamount",
    //         headerName: "Total Sales Amount",
    //     },
    //     {
    //         field: "totalareasold",
    //         headerName: "Total Area Sold",
    //     },
    //     {
    //         field: "totalunitssold",
    //         headerName: "Total Units Sold",
    //     },
    // ]

    function numDifferentiation(value) {
        const val = Math.abs(value)
        if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`
        if (val >= 100000) return `${(value / 100000).toFixed(2)} Lac`
        return value;
    }

    function getYears(year) {
        let arr = []
        for (let i = 0; i < 100; i++) {
            arr.push(year)
            year = year + 1
        }
        return arr
    }

    const options = {
        responsive: true,
        barThickness: 15,
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                grid: {
                    display: false
                }
            }
        }
    };

    useEffect(() => {
        let arr = []
        let currTab = ''
        if (JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Dashboard?.Projects) {
            arr.push({
                text: "Projects",
                value: "Projects",
                isSelected: true,
                key: 0,
            })
            currTab = 'Projects'
        }
        if (JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Dashboard?.CP) {
            arr.push({
                text: "CP",
                value: "CP",
                isSelected: true,
                key: 0,
            })
            if (currTab === '') {
                currTab = 'CP'
            }
        }
        // if (JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Dashboard?.Sales) {
        //     arr.push({
        //         text: "Sales",
        //         value: "Sales",
        //         isSelected: true,
        //         key: 0,
        //     })
        // }
        if (JSON.parse(localStorage.getItem('user')).roleId.accessibleTabs.Dashboard?.Events) {
        arr.push({
            text: "Events",
            value: "Events",
            isSelected: true,
            key: 0,
        })
        if (currTab === '') {
            currTab = 'Events'
        }
        }
        setTabs(arr)
        setTabValue(currTab)
    }, [])

    // const labels = ["January", "February", "March", "April", "May", "June", "July"];
    const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

    useEffect(() => {
        dispatch(actions.activeMenu('dashboard'));
        presentLoader()
        if (mode === 'project wise') {
            // getDataUnitTypeWiseForProject().then((resp) => {
            //     dismissLoader()
            //     console.log(resp)
            // }).catch((err) => {
            dismissLoader()
            // })
        } else if (mode === 'unit analysis') {
            let project = []
            if (projectForUnits === 'All') {
                project = projects
            } else {
                project.push(projectForUnits)
            }
            getUnitAnalysis(project).then((unitCountRes) => {
                setUnitCounts(unitCountRes[0])
                getTokenWiseUnitsSold(project).then(async (tokenWiseUnitsRes) => {
                    setTokenWiseUnits(tokenWiseUnitsRes)
                    let topSalesInEventRes = await getTopSalesInEvent(project)
                    setTopSalesInEvent(topSalesInEventRes)
                    let topSalesInSustenanceRes = await getTopSalesInSustenance(project)
                    setTopSalesInSustenance(topSalesInSustenanceRes)
                    dismissLoader()
                })
            })
        } else if (mode === 'booking in progress') {
            setSelectedProjectForBookingInProgress(currentProjectForAll)
            dismissLoader()
        } else {
            if (tabValue === 'Projects') {
                let teamIds = [];
                if (loggedInUser?.roleId?.accessibleTabs?.Dashboard?.Projects?.["Show All Analysis"]?.show === "Team wise") {
                    teamIds = JSON.parse(localStorage.getItem('teamIds'));
                }

                getAllCounts(currentYear, teamIds, projects).then((resp) => {
                    let obj = { ...resp[0] }
                    obj.totalareasold = JSON.parse(obj.totalareasold)
                    obj.totalsalesamount = JSON.parse(obj.totalsalesamount)
                    obj.totalunitssold = JSON.parse(obj.totalunitssold)
                    console.log(obj)
                    setAllCounts(obj)
                    dismissLoader()
                }).catch((err) => {
                    console.log(err)
                    dismissLoader()
                })
            } else if (tabValue === 'CP') {
                getCpData()
            } else if (tabValue === 'Overview') {
                dismissLoader()
            }
        }
    }, [currentYear, mode, projectForUnits])

    useEffect(() => {
        dispatch(actions.activeMenu('dashboard'));
        // if (showProjectWise) {
        //     // getProjectData()
        // } else {
        if (tabValue === 'Projects') {
            getAllData()
        } else if (tabValue === 'CP') {
            getAllCp()
        }
        //  else if (tabValue === 'Sales') {
        //     // if (JSON.parse(localStorage.getItem('user')).roleId.level === 1) {
        //     //     setAllTeams([])
        //     //     supabase.from('Users').select('*').eq('isTeamLead', true).then((teams) => {
        //     //         if (teams.data.length > 0) {
        //     //             console.log(teams.data)
        //     //             setCurrentTeamLead(teams.data[0].name)
        //     //             setAllTeams(teams.data)
        //     //         } else {
        //     //             let team = JSON.parse(localStorage.getItem('teamIds'))
        //     //             setCurrentTeam(team)
        //     //             supabase.from('Users').select('userId, name').in('userId', team).then((teammembers) => {
        //     //                 console.log('teammembers: ', teammembers);
        //     //                 setCurrentTeamMembers(teammembers.data);
        //     //                 getSalesData('All', team, teammembers.data)
        //     //             });
        //     //         }
        //     //     })
        //     // } else {
        //     //     let team = JSON.parse(localStorage.getItem('teamIds'))
        //     //     setCurrentTeam(team)
        //     //     // getSalesData('All', team)
        //     //     supabase.from('Users').select('userId, name').in('userId', team).then((teammembers) => {
        //     //         console.log('teammembers: ', teammembers);
        //     //         setCurrentTeamMembers(teammembers.data);
        //     //         getSalesData('All', team, teammembers.data)
        //     //     });
        //     // }
        //     // setCurrentProject(projects[0])
        //     if (currentProjectForAll !== '') {
        //         let arr = []
        //         if (currentProjectForAll === 'All') {
        //             arr = projects
        //         } else {
        //             arr = [currentProjectForAll]
        //         }
        //         supabase.from('Projects').select('projectId').in('projectName', arr).then((projectIdRes) => {
        //             let data = []
        //             projectIdRes.data.forEach((ele) => {
        //                 data.push(ele.projectId)
        //             })
        //             supabase.from('SustenanceSalesRelations').select('userId(*)').in('projectId', data).eq('userId.isTeamLead', true).then(async (userRes) => {
        //                 let teams = []
        //                 let teamIds = []
        //                 for (const ele of userRes.data) {
        //                     if (ele.userId) {
        //                         let team = {
        //                             teamLead: ele.userId.name,
        //                             team: []
        //                         }
        //                         let userIds = [ele.userId.userId]
        //                         let i = 0
        //                         let allUsers = [ele.userId];
        //                         let { ids, users } = await getTeam(userIds, i, allUsers)
        //                         teamIds = [...teamIds, ...ids]
        //                         team.team = users
        //                         teams.push(team)
        //                     }
        //                 }
        //                 console.log(teams)
        //                 console.log(teamIds)
        //                 getSalesData(data, teamIds, teams)
        //             })
        //         })
        //     }
        // } 
        else if (tabValue === 'Events') {
            supabase.from('LaunchSalesRelations').select('*,launchId(eventId(*))').in('userId', JSON.parse(localStorage.getItem('teamIds'))).then((eventResp) => {
                let arr = []
                for (const ele of eventResp.data) {
                    // if (!arr.includes(ele.launchId.eventId)) {
                    arr.push(ele.launchId.eventId)
                    // }
                }
                setAllEvents(uniqBy(arr, 'eventId'))
                setEvent(uniqBy(arr, 'eventId')[0])
            })
        }
        // }
    }, [tabValue])

    useEffect(() => {
        if (event) {
            supabase.from('EventTokenLeadRelations').select('*,eventTokenId(*,tokenId(*))').eq('eventId', event.eventId).then((resp) => {
                let obj = {}
                obj.total = resp.data.length
                obj.preselect = resp.data.filter((ele) => { return ele.eventTokenId.tokenId.isPreselect }).length
                obj.prioritypass = resp.data.filter((ele) => { return ele.eventTokenId.tokenId.isPriorityPass }).length
                obj.other = resp.data.filter((ele) => { return !ele.eventTokenId.tokenId.isPreselect && !ele.eventTokenId.tokenId.isPriorityPass }).length
                obj.checkpt1 = resp.data.filter((ele) => { return ele.checkpt1 }).length
                obj.checkpt2 = resp.data.filter((ele) => { return ele.checkpt2 }).length
                console.log(obj)
            })
        }
    }, [event])

    useEffect(() => {
        setUsers([])
        setProjectCounts(null)
        if (currentProjectForAll !== '') {
            let arr = []
            if (currentProjectForAll === 'All') {
                arr = projects
            } else {
                arr = [currentProjectForAll]
            }
            if (tabValue === 'Overview') {
                let teamIds = [];
                if (loggedInUser?.roleId?.accessibleTabs?.Dashboard?.Projects?.["Show All Analysis"]?.show === "Team wise") {
                    teamIds = JSON.parse(localStorage.getItem('teamIds'));
                }
                getAllCounts(currentYear, teamIds, arr).then((resp) => {
                    let obj = { ...resp[0] }
                    obj.totalareasold = JSON.parse(obj.totalareasold)
                    obj.totalsalesamount = JSON.parse(obj.totalsalesamount)
                    obj.totalunitssold = JSON.parse(obj.totalunitssold)
                    console.log(obj)
                    setAllCounts(obj)
                }).catch((err) => {
                    console.log(err)
                })
                getTopProjects(teamIds).then((resp) => {
                    resp.forEach((ele, index) => {
                        ele.id = index
                        ele.key = index
                    })
                    setTopProjects(resp)
                    dismissLoader()
                }).catch((err) => {
                    console.log(err)
                })
                getTopSales(teamIds, arr).then((resp) => {
                    resp.forEach((ele, index) => {
                        ele.id = index
                        ele.key = index
                    })
                    setTopSales(resp)
                    dismissLoader()
                }).catch((err) => {
                    console.log(err)
                })
                setUserIds(teamIds)
            } else if (tabValue === 'Sales') {
                supabase.from('Projects').select('projectId').eq('isVJ', true).in('projectName', arr).then((projectIdRes) => {
                    console.log(projectIdRes)
                    let data = []
                    projectIdRes.data.forEach((ele) => {
                        data.push(ele.projectId)
                    })
                    supabase.from('SustenanceSalesRelations').select('userId(*)').in('projectId', data).eq('userId.isTeamLead', true).then(async (userRes) => {
                        let teams = []
                        let teamIds = []
                        for (const ele of userRes.data) {
                            if (ele.userId) {
                                let team = {
                                    teamLead: ele.userId.name,
                                    team: []
                                }
                                let userIds = [ele.userId.userId]
                                let i = 0
                                let allUsers = [ele.userId];
                                let { ids, users } = await getTeam(userIds, i, allUsers)
                                teamIds = [...teamIds, ...ids]
                                team.team = users
                                teams.push(team)
                            }
                        }
                        console.log(teams)
                        console.log(teamIds)
                        getSalesData(data, teamIds, teams)
                    })
                })
            } else if (tabValue === 'Inventory') {
                supabase.from('Projects').select('projectId').eq('isVJ', true).eq('projectName', currentProjectForAll).then((resp) => {
                    getDataForGraph(resp.data[0].projectId);
                    // setMode('project wise')
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
    }, [currentProjectForAll])

    useEffect(() => {
        if (currentProjectForAll !== '') {
            let arr = []
            if (currentProjectForAll === 'All') {
                arr = projects
            } else {
                arr = [currentProjectForAll]
            }
            if (tabValue === 'Sales' && users.length === 0) {
                supabase.from('Projects').select('projectId').eq('isVJ', true).in('projectName', arr).then((projectIdRes) => {
                    console.log(projectIdRes)
                    let data = []
                    projectIdRes.data.forEach((ele) => {
                        data.push(ele.projectId)
                    })
                    supabase.from('SustenanceSalesRelations').select('userId(*)').in('projectId', data).eq('userId.isTeamLead', true).then(async (userRes) => {
                        let teams = []
                        let teamIds = []
                        for (const ele of userRes.data) {
                            if (ele.userId) {
                                let team = {
                                    teamLead: ele.userId.name,
                                    team: []
                                }
                                let userIds = [ele.userId.userId]
                                let i = 0
                                let allUsers = [ele.userId];
                                let { ids, users } = await getTeam(userIds, i, allUsers)
                                teamIds = [...teamIds, ...ids]
                                team.team = users
                                teams.push(team)
                            }
                        }
                        console.log(teams)
                        console.log(teamIds)
                        getSalesData(data, teamIds, teams)
                    })
                })
            } else if (tabValue === 'Inventory' && !projectCounts) {
                supabase.from('Projects').select('projectId').eq('isVJ', true).eq('projectName', currentProjectForAll).then((resp) => {
                    getDataForGraph(resp.data[0].projectId);
                    // setMode('project wise')
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
    }, [tabValue])

    async function getAllData() {
        // presentLoader()
        let arr = []
        let allProjects = null
        setTabValue('Overview')
        if (JSON.parse(localStorage.getItem('user')).roleId.level === 1) {
            allProjects = await supabase.from('Projects').select('projectName').eq('isVJ', true)
            console.log(allProjects)
            allProjects.data.forEach((ele) => {
                arr.push(ele.projectName)
            })
        } else {
            allProjects = await supabase.from('SustenanceSalesRelations').select('projectId!inner(projectName)').eq('projectId.isVJ', true).eq('userId', JSON.parse(localStorage.getItem('user')).userId)
            console.log(allProjects)
            allProjects.data.forEach((ele) => {
                arr.push(ele.projectId.projectName)
            })
        }
        setProjects(sortBy(arr))
        console.log("projects1",projects)

        setCurrentProjectForAll(sortBy(arr)[0])
    }

    function numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
    }

    async function getAllCp() {
        setTopFos([])
        let cps = await getCp()
        cps.forEach((e) => { e.label = e.billingName; e.value = e.billingName })
        setAllCp(cps)
        if (cps.length > 0) {
            let arr = []
            cps.forEach((ele) => {
                arr.push(ele.cpId)
            })
            setSelectedCp(arr)
        }
    }

    async function getCpData() {
        presentLoader()
        let cpProjects = await getdataforcpdoughnut(currentYear, selectedCp)
        console.log(cpProjects)
        let counts = await cpAnalytics(selectedCp)
        let resp = await getTopFosByCp(selectedCp)
        resp.forEach((ele, index) => {
            ele.id = index
            ele.key = index
        })
        setTopFos(resp)
        setCpCounts(counts[0])
        setCpProjectData(cpProjects)
        dismissLoader()
    }

    function add(accumulator, a) {
        return accumulator + a;
    }

    const tabChange = (event, newValue) => {
        setTabValue(newValue);

    }

    const tabList = tabs.map((each, index) => {
        return (
            <Tab
                label={each}
                key={index}
                value={each}
                sx={[
                    {
                        fontFamily: "Inter-Medium !important",
                        fontStyle: "normal !important",
                        fontWeight: "500 !important",
                        fontSize: "1.4rem !important",
                        lineHeight: "2rem !important",
                        textTransform: "none !important",
                    },
                ]}
            />
        );
    });

    useEffect(() => {
        setTopSales([])
        console.log(selectedProject)
        if (selectedProject) {
            supabase.from('Projects').select('projectId').eq('isVJ', true).eq('projectName', selectedProject).then((resp) => {
                getDataForGraph(resp.data[0].projectId);
                setMode('project wise')
            }).catch((err) => {
                console.log(err)
            })
        }
    }, [selectedProject])

    useEffect(() => {
        if (selectedProjectForBookingInProgress && selectedProjectForBookingInProgress !== '') {
            supabase.rpc('bookinginprogresscounts', { usersarray: userIds, projectarray: selectedProjectForBookingInProgress === 'All' ? projects : [selectedProjectForBookingInProgress] }).then((resp) => {
                setBookingInProgressCounts(resp.data[0])
            })
        }
    }, [selectedProjectForBookingInProgress])

    useEffect(() => {
        if (selectedCp) {
            getCpData()
        }
    }, [selectedCp])

    async function getProjectData() {
        setTopSales([])
        // let projects = await getProjects()
        // projects.forEach((e) => { e.label = e.projectName; e.value = e.projectName })
        // console.log('projects: ', projects);
        // setAllProjects(projects)
        // if (projects.length > 0) {
        //     setSelectedProject(projects[0].projectId)
        // }
    }

    async function getDataForGraph(projectId) {
        presentLoader()
        let unitWiseRes = await getDataUnitTypeWiseForProject(projectId)
        let counts = await projectAnalytics(projectId)
        let resp = await getTopSalesByProject(projectId)
        console.log(resp)
        resp.forEach((ele, index) => {
            ele.id = index
            ele.key = index
        })
        let cp = await getTopCpByProject(projectId)
        console.log(resp)
        resp.forEach((ele, index) => {
            ele.id = index
            ele.key = index
        })
        setTopSales(resp)
        setTopCp(cp)
        setProjectCounts(counts[0])
        dismissLoader()
    }

    async function getDataUnitTypeWiseForProject(projectId) {
        return new Promise(async (resolve, reject) => {
            let unitTypes = await getUniqueUnitTypes(projectId)
            let arr = []
            let i = 0
            for (const type of unitTypes) {
                let unitsSold = await getCountsByYearForProject(currentYear, type.type, projectId)
                arr.push({
                    label: type.type,
                    data: unitsSold,
                    backgroundColor: colors[i]
                })
                i = i + 1
            }
            setUnitSoldData(arr)
            resolve(true)
        })
    }

    function cpUi() {
        return (
            <>
                {selectedCp.length > 0 &&
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5rem',
                        marginBottom: '2rem'
                    }}>
                        {/* <p className={cssClasses.button} onClick={() => setShowProjectWise(false)}>Back</p> */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2rem',
                            // width: '35%',
                            flex: 1
                        }}>
                            <p style={{ fontSize: '2rem' }}>CP&nbsp;:</p>
                            {/* <DropDown onChangeSelect={(e) => {
                                setSelectedCp(allCp.filter((ele) => { return ele.billingName === e })[0]?.cpId)
                            }} list={allCp} selectedValue={allCp.filter((e) => { return e.cpId === selectedCp })[0]?.billingName} /> */}
                            <div style={{ width: "min(250px, 100%)" }}>
                                <CustomAutoComplete NoOptionsText={'No CP found'}
                                    InitialValue={(e) => {
                                        if (!e || e === 'All') {
                                            let arr = []
                                            allCp.forEach((ele) => {
                                                arr.push(ele.cpId)
                                            })
                                            setSelectedCp(arr)
                                        } else {
                                            setSelectedCp([allCp.filter((ele) => { return ele.billingName === e })[0]?.cpId])
                                        }
                                    }}
                                    list={[{ billingName: 'All' }, ...sortBy(allCp, 'billingName')].map((m) => m.billingName)} multiple={false} disable={false}
                                    value={selectedCp.length > 1 ? 'All' : allCp.filter((e) => {
                                        return e.cpId === selectedCp[0]
                                    })[0]?.billingName}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className={cssClasses.totalCountsDiv}>
                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 24 }}>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalLeads} number={cpCounts?.totalleads} title={'Total Leads'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={activeLeads} number={cpCounts?.activeleads} title={'Active Leads'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalTokens} number={cpCounts?.sitevisitleads} title={'Site Visit'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalAllotments} number={cpCounts?.tokenleads} title={'Token'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={agreementDone} number={cpCounts?.allotmentleads} title={'Allotment'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={agreementDone} number={cpCounts?.agreementleads} title={'Agreement Done'} />
                        </Grid>
                    </Grid>
                </div>
                <div className={cssClasses.earningSummary}>
                    <Card className={cssClasses.dounghnut} style={{ width: "100%", height: '35rem', padding: '2.4rem', flex: '10%' }}>
                        <div className={cssClasses.headerDiv}>
                            <p className={cssClasses.graphTitle}>Units Sold</p>
                            <div>
                                <DropDown list={yearList} selectedValue={currentYear} onChangeSelect={((e) => { setCurrentYear(e) })} />
                            </div>
                        </div>
                        <Card style={{ boxShadow: 'unset', height: 'calc(90% - 3rem)', width: '100%' }}>
                            <Doughnut style={{ width: "500px !important", height: '100% !important' }}
                                options={{
                                    plugins: {
                                        legend: {
                                            position: 'right'
                                        }
                                    }
                                }}
                                data={{
                                    labels: orderBy(cpProjectData, ['unitssold'], ['desc'])?.map((m) => { return m.projectname }),
                                    datasets: [
                                        {
                                            label: 'units sold',
                                            data: orderBy(cpProjectData, ['unitssold'], ['desc'])?.map((m) => { return m.unitssold }),
                                            backgroundColor: colors,
                                            borderColor: colors,
                                        }
                                    ]
                                }} />
                        </Card>
                    </Card>
                    <Card style={{ padding: '2.4rem', flex: '35%', maxHeight: '350px', overflowY: 'auto' }}>
                        {orderBy(cpProjectData, ['unitssold'], ['desc']).map((m, i) => (
                            <div className={cssClasses.graphCountsDiv}>
                                {/* <p style={{ color: colors[i] }}>Hello</p> */}
                                <div style={{ width: '5rem', height: '2rem', color: colors[i], background: colors[i] }}></div>
                                <p>{m.projectname}</p>
                                <p>{m.unitssold}</p>
                            </div>
                        ))
                        }
                    </Card>
                </div>
                <div className={cssClasses.performance}>
                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                <div className={cssClasses.cardHeader}>
                                    <Project color={"#FFFF"} fill={"#1570EF"} />
                                    <p>Top Performing FOS</p>
                                </div>
                                <div className={cssClasses.projectsHeader}>
                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Leads</p>
                                </div>
                                {topFos.map((m) => (
                                    <>
                                        {m.fosname &&
                                            < div className={cssClasses.projectsHeader} >
                                                <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.fosname}</p>
                                                <p style={{ flex: '20%', textAlign: 'center', }} className={cssClasses.projectFields}>{m.totalleads}</p>
                                            </div>
                                        }
                                    </>
                                ))
                                }
                                {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </>
        )
    }

    function getSalesData(selectedProject, team, teamMembers) {
        presentLoader()
        setUsers([])
        // let projectsToUse = []
        console.log(projects)
        // if (selectedProject === 'All') {
        //     projectsToUse = projects
        // } else {
        //     projectsToUse.push(selectedProject)
        // }
        getTokenDataBySalesTeam(team, selectedProject).then(async (resp) => {
            let tokenArr = []
            resp.forEach((ele) => {
                if (!tokenArr.includes(ele.token)) {
                    tokenArr.push(ele.token)
                }
            })
            setTokensForSales(tokenArr)
            const allCounts = [];
            for (const teamLead of teamMembers) {
                for (const ele of teamLead.team) {
                    // console.log('ele.userId: ', ele.userId);
                    let leads = await supabase.from('Leads').select('*,userId').eq('userId', ele.userId)
                    // console.log('leads: ', leads);
                    ele.leads = leads.data.length;
                    let sitevisits = await supabase.rpc('getsitevisitsbyprojectanduser', { usersarray: [ele.name], projectarray: selectedProject })
                    ele.siteVisit = sitevisits.data[0].num;
                    let allotments = await supabase.rpc('getallotmentsbyprojectanduser', { usersarray: [ele.name], projectarray: selectedProject })
                    ele.preselectAllotments = allotments.data[0].preselectcount;
                    ele.sustenanceAllotments = allotments.data[0].sustenancecount;
                    ele.eventAllotments = allotments.data[0].eventcount;
                    // console.log('projectsToUse: ', projectsToUse);
                    // console.log('sitevisits: ', sitevisits);
                    // let sitevisits = await supabase.from('SiteVisits').select('*').in('userId', team).in('projectId', )
                    ele.preselectToken = resp.filter((tk) => { return ele.name === tk.username && tk.ispreselect }).length;
                    ele.token = resp.filter((tk) => { return ele.name === tk.username && !tk.ispreselect }).length;
                    // for (const token of tokenArr) {
                    //     // console.log('tokens', resp.filter((tk) => { return ele.name === tk.username && token === tk.token }));
                    //     ele[token] = resp.filter((tk) => { return ele.name === tk.username && token === tk.token }).length
                    // }
                }
                allCounts.push(teamLead);
            }
            // let users = groupBy(resp, 'username')
            // Object.keys(users).forEach(async (ele) => {
            // for (const ele of Object.keys(users)) {
            //     let obj = users[ele]
            //     users[ele] = {}
            //     users[ele].tokens = groupBy(obj, 'token')
            //     let leads = await supabase.from('Leads').select('*,userId(*)').eq('userId.name', ele)
            //     users[ele].leads = leads.data.filter((ele) => { return ele.userId }).length
            //     let sitevisits = await supabase.rpc('getsitevisitsbyprojectanduser', { usersarray: [ele], projectarray: projectsToUse })
            //     users[ele].sitevisits = sitevisits.data[0].num
            // }
            setUsers(allCounts)
            console.log(allCounts)
            dismissLoader()
        }).catch((err) => {
            console.log(err)
            dismissLoader()
        })
    }

    useEffect(() => {
        console.log(currentTeamLead)
        setProjects([])
        if (currentTeamLead) {
            let arr = []
            supabase.from('SustenanceSalesRelations').select('projectId!inner(projectName)').eq('projectId.isVJ', true).eq('userId', allTeams.filter((ele) => { return ele.name === currentTeamLead })[0].userId).then((allProjects) => {
                console.log(allProjects)
                for (const ele of allProjects.data) {
                    arr.push(ele.projectId.projectName)
                }
                setProjects(sortBy(arr))
        console.log("projects2",projects)

            })
        }
    }, [currentTeamLead])

    useEffect(() => {
        if (currentProject !== '') {
            presentLoader()
            console.log(currentProject)
            supabase.from('Projects').select('projectId').eq('isVJ', true).eq('projectName', currentProject).then((projectIdRes) => {
                supabase.from('SustenanceSalesRelations').select('userId(*)').eq('projectId', projectIdRes.data[0].projectId).eq('userId.isTeamLead', true).then(async (userRes) => {
                    let teams = []
                    let teamIds = []
                    for (const ele of userRes.data) {
                        if (ele.userId) {
                            let team = {
                                teamLead: ele.userId.name,
                                team: []
                            }
                            let userIds = [ele.userId.userId]
                            let i = 0
                            let allUsers = [ele.userId];
                            let { ids, users } = await getTeam(userIds, i, allUsers)
                            teamIds = [...teamIds, ...ids]
                            team.team = users
                            teams.push(team)
                        }
                    }
                    console.log(teams)
                    console.log(teamIds)
                    getSalesData(currentProject, teamIds, teams)
                })
            })
        }
    }, [currentProject])

    // useEffect(() => {
    //     if (projects && tabValue === 'Sales') {
    //         let teamLeadId = allTeams.filter((ele) => { return ele.name === currentTeamLead })[0]?.userId
    //         let userIds = [teamLeadId]
    //         let i = 0
    //         let allUsers = [];
    //         getTeam(userIds, i, allUsers)
    //     }
    // }, [projects])

    useEffect(() => {
        console.log(users)
    }, [users])

    async function getTeam(userIds, i, allUsers) {
        const { data, error } = await supabase.from('Users').select('*').eq('parentId', userIds[i])
        if (data) {
            console.log('data: ', data);
            data.forEach((id) => {
                userIds.push(id.userId)
                const userData = {
                    userId: id.userId,
                    name: id.name
                }
                allUsers.push(userData);
            });
            i++;
            if (i === userIds.length) {
                // resolve(userIds)
                // setCurrentTeam(userIds)
                return { users: allUsers, ids: userIds };
                // getSalesData('All', userIds, allUsers)
            } else {
                return getTeam(userIds, i, allUsers);
            }
        }
    }

    function salesUi() {
        return (
            <>
                <div>
                    {/* <div className={cssClasses.dropdownWrapper}> */}
                    {/* <DropDown list={projects}
                            onChangeSelect={(e) => {
                                // getSalesData(e, currentTeam, currentTeamMembers)
                                setCurrentProject(e)
                            }}
                            selectedValue={currentProject}
                            label={'Select Project'} placeHolder={'Select Project'}
                        /> */}
                    {/* <p style={{ fontSize: '2rem' }}>Project&nbsp;: </p> */}
                    {/* <div style={{ width: "min(250px, 100%)" }}>
                            <CustomAutoComplete NoOptionsText={'No project found'}
                                InitialValue={(e) => {
                                    setCurrentProject(e)
                                }}
                                list={projects} multiple={false} disable={false}
                                value={currentProject}
                            /> */}
                    {/* <DropDown list={allTeams.map((m) => m.name)}
                                selectedValue={currentTeamLead}
                                onChangeSelect={(e) => {
                                    setCurrentTeamLead(e)
                                    setCurrentProject('All')
                                }}
                                label={'Select Team Lead'} placeHolder={'Select Team Lead'}
                            /> */}
                    {/* </div>
                    </div> */}
                    <div className={cssClasses.salesTable}>
                        <Table sx={{ overflowX: 'auto', '.MuiTableHead-root': { background: '#F9FAFB', border: '1px solid #E5E7EB' }, '.MuiTableCell-root': { fontSize: '1.4rem', whiteSpace: 'nowrap' }, '.MuiTableRow-root': { border: '1px solid #E5E7EB' } }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>User</TableCell>
                                    <TableCell align="center">Leads</TableCell>
                                    <TableCell align="center">Site Visits</TableCell>
                                    <TableCell align="center">Preselect Tokens</TableCell>
                                    <TableCell align="center">Tokens</TableCell>
                                    <TableCell align="center">Preselect Allotments</TableCell>
                                    <TableCell align="center">Sustenance Allotments</TableCell>
                                    <TableCell align="center">Event Allotments</TableCell>
                                    {/* {tokensForSales.map((m) => (
                                        <TableCell align="center">{m}</TableCell>
                                    ))
                                    } */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* {Object.keys(users).map((row) => ( */}
                                {users.map((user, index) => (
                                    <>
                                        {user.team.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell style={{ fontWeight: user.teamLead === row.name ? '600' : '400' }} align="left">{user.teamLead === row.name ? `${row.name} (TL)` : row.name}</TableCell>
                                                <TableCell align="center">{row.leads}</TableCell>
                                                <TableCell align="center">{row.siteVisit}</TableCell>
                                                <TableCell align="center">{row.preselectToken}</TableCell>
                                                <TableCell align="center">{row.token}</TableCell>
                                                <TableCell align="center">{row.preselectAllotments}</TableCell>
                                                <TableCell align="center">{row.sustenanceAllotments}</TableCell>
                                                <TableCell align="center">{row.eventAllotments}</TableCell>
                                                {/* {tokensForSales.map((m) => (
                                                    <TableCell align="center">{row[m] ? row[m] : 0}</TableCell>
                                                    // <TableCell align="center">{users[row].tokens[m] ? users[row].tokens[m].length : 0}</TableCell>
                                                ))
                                                } */}
                                            </TableRow>
                                        ))
                                        }
                                        <TableRow
                                            key={'Total'}
                                            sx={{ background: '#F9FAFB', '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="left">{'Total'}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.leads).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.siteVisit).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.preselectToken).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.token).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.preselectAllotments).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.sustenanceAllotments).reduce(add, 0)}</TableCell>
                                            <TableCell align="center">{user.team.map((m) => m.eventAllotments).reduce(add, 0)}</TableCell>
                                            {/* {tokensForSales.map((token) => (
                                                <TableCell align="center">{user.team.map((m) => m[token] || 0).reduce(add, 0)}</TableCell>
                                                // <TableCell align="center">{Object.keys(users).map((m) => users[m].tokens[token]?.length || 0).reduce(add, 0)}</TableCell>
                                            ))
                                            } */}
                                        </TableRow>
                                        <TableRow
                                            key={'Total'}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="left"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            {tokensForSales.map((token) => (
                                                <TableCell align="center"></TableCell>
                                                // <TableCell align="center">{Object.keys(users).map((m) => users[m].tokens[token]?.length || 0).reduce(add, 0)}</TableCell>
                                            ))
                                            }
                                        </TableRow>
                                    </>
                                ))}

                            </TableBody>
                        </Table>
                    </div>
                </div>
            </>
        )
    }

    function viewDetailsClicked(e) {
        console.log(e);
        if (e === 'Booking Done') {
            setMode('unit analysis')
        }
        if (e === 'Total Tokens') {
            setMode('Total Tokens analysis')
        }
        if (e === 'Booking In Progress') {
            setMode('booking in progress')
        }
    }

    function unitAnalysis() {
        return (
            <>
                {projectForUnits &&
                    <div style={{
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: '5rem',
                        marginBottom: '2rem'
                    }}>
                        <p className={cssClasses.button} onClick={() => { setMode('all'); setSelectedProject('') }}>Back</p>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2rem',
                            width: '100%',
                            marginBottom: '2rem'
                        }}>
                            <p style={{ fontSize: '2rem' }}>Project&nbsp;:</p>
                            <div style={{ width: 'min(250px, 100%)' }}>
                                {/* <DropDown onChangeSelect={(e) => {
                                                    // setSelectedProject(allProjects.filter((ele) => { return ele.projectName === e })[0]?.projectId)
                                                    setCurrentProjectForAll(e)
                                                    // }} list={allProjects} selectedValue={allProjects.filter((e) => { return e.projectId === selectedProject })[0]?.projectName} />
                                                }} list={[...['All'], ...projects]} selectedValue={currentProjectForAll} /> */}
                                <CustomAutoComplete NoOptionsText={'No project found'}
                                    InitialValue={(e) => {
                                        if (!e || e === 'All') {
                                            setProjectForUnits('All')
                                        } else {
                                            setProjectForUnits(e)
                                        }
                                    }}
                                    list={['All', ...projects]} multiple={false} disable={false}
                                    value={projectForUnits}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className={cssClasses.totalCountsDiv}>
                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalLeads} number={unitCounts?.booked} title={'Booking Done'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={activeLeads} number={unitCounts?.event} title={'Event'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalTokens} number={unitCounts?.sustenance} title={'Sustenance'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={totalAllotments} number={unitCounts?.preselect} title={'Preselect'} />
                        </Grid>
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <DashboardCard icon={agreementDone} number={unitCounts?.totalevents} title={'Total Events'} />
                        </Grid>
                    </Grid>
                </div>
                {(unitCounts?.event > 0 || unitCounts?.preselect > 0) &&
                    < div className={cssClasses.earningSummary}>
                        <Card className={cssClasses.dounghnut} style={{ width: "100%", height: '35rem', padding: '2.4rem', flex: '10%' }}>
                            <div className={cssClasses.headerDiv}>
                                <p className={cssClasses.graphTitle}>Units Sold</p>
                                {/* <div>
                                <DropDown list={yearList} selectedValue={currentYear} onChangeSelect={((e) => { setCurrentYear(e) })} />
                            </div> */}
                            </div>
                            <Card style={{ boxShadow: 'unset', height: 'calc(90% - 3rem)', width: '100%' }}>
                                <Doughnut style={{ width: "500px !important", height: '100% !important' }}
                                    options={{
                                        plugins: {
                                            legend: {
                                                position: 'right'
                                            }
                                        }
                                    }}
                                    data={{
                                        labels: orderBy(tokenWiseUnits, ['units'], ['desc'])?.map((m) => { return m.tokenname }),
                                        datasets: [
                                            {
                                                label: 'units sold',
                                                data: orderBy(tokenWiseUnits, ['units'], ['desc'])?.map((m) => { return m.units }),
                                                backgroundColor: colors,
                                                borderColor: colors,
                                            }
                                        ]
                                    }} />
                            </Card>
                        </Card>
                        <Card style={{ padding: '2.4rem', flex: '35%', maxHeight: '350px', overflowY: 'auto' }}>
                            {orderBy(tokenWiseUnits, ['units'], ['desc']).map((m, i) => (
                                <div className={cssClasses.graphCountsDiv}>
                                    {/* <p style={{ color: colors[i] }}>Hello</p> */}
                                    <div style={{ width: '5rem', height: '2rem', color: colors[i], background: colors[i] }}></div>
                                    <p>{m.tokenname}</p>
                                    <p>{m.units}</p>
                                </div>
                            ))
                            }
                        </Card>
                    </div >
                }
                <div className={cssClasses.performance}>
                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
                        {(unitCounts?.event > 0 || unitCounts?.preselect > 0) &&
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                    <div className={cssClasses.cardHeader}>
                                        <Project color={"#FFFF"} fill={"#1570EF"} />
                                        <p>Top Performing User's in event</p>
                                    </div>
                                    <div className={cssClasses.projectsHeader}>
                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Units</p>
                                    </div>
                                    {topSalesInEvent.map((m) => (
                                        <>
                                            {m.salesname &&
                                                < div className={cssClasses.projectsHeader} >
                                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.salesname}</p>
                                                    <p style={{ flex: '20%', textAlign: 'center', }} className={cssClasses.projectFields}>₹ {numDifferentiation(m.totalamount)}</p>
                                                    <p style={{ flex: '20%', textAlign: 'center', }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                </div>
                                            }
                                        </>
                                    ))
                                    }
                                    {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                </Card>
                            </Grid>
                        }
                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                            <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                <div className={cssClasses.cardHeader}>
                                    <Project color={"#FFFF"} fill={"#1570EF"} />
                                    <p>Top Performing User's in sustenance</p>
                                </div>
                                <div className={cssClasses.projectsHeader}>
                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Units</p>
                                </div>
                                {topSalesInSustenance.map((m) => (
                                    <>
                                        {m.salesname &&
                                            < div className={cssClasses.projectsHeader} >
                                                <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.salesname}</p>
                                                <p style={{ flex: '20%', textAlign: 'center', }} className={cssClasses.projectFields}>₹ {numDifferentiation(m.totalamount)}</p>
                                                <p style={{ flex: '20%', textAlign: 'center', }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                            </div>
                                        }
                                    </>
                                ))
                                }
                                {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </>
        )
    }

    return (
        <div className={cssClasses.mainContainer}>
            {tabs.length > 0 &&
                <>
                    <div style={{ marginBottom: '2rem' }}>
                        <div className={cssClasses.tabsWrapper} style={{ height: "100%" }}>
                            <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
                                <TabContext value={tabs.find(f => f.isSelected).value}>
                                    <TabsMenu
                                        selectedColor={"#1570EF"}
                                        selectedBackgroundColor={"#FFFFFF"}
                                        stylesForTab={{
                                            color: '#344054',
                                            fontSize: '1.6rem',
                                            fontStyle: 'normal',
                                            fontWeight: '500',
                                            lineHeight: '2.4rem',
                                            padding: "0.8rem 1.2rem",
                                            textTransform: 'unset',
                                            borderBottom: "1px solid #EAECF0"
                                        }}
                                        borderColor={"#1570EFs"}
                                        stylesForWrapper={{
                                            padding: "1.5rem 0",
                                            background: "#FFFFFF",
                                        }}
                                        list={tabs}
                                        value={tabs.find(f => f.isSelected).value}
                                        handleChange={(e, value) => {
                                            tabChange(e, value)
                                            setTabs((pre) => {
                                                pre.forEach((ele) => {
                                                    if (ele.value === value) {
                                                        ele.isSelected = true
                                                    } else {
                                                        ele.isSelected = false
                                                    }
                                                })
                                                return [...pre]
                                            })
                                        }}
                                    />
                                    <TabPanel style={{ height: "calc(100% - 7rem)", padding: "0rem 0rem 2rem 1rem !important" }} className={cssClasses.Tabs} value={"Projects"} index={0}>
                                        {mode === 'all' &&
                                            <>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '2rem',
                                                    width: '100%',
                                                    marginBottom: '2rem'
                                                }}>
                                                    <p style={{ fontSize: '2rem' }}>Project&nbsp;:</p>
                                                    <div style={{ width: 'min(250px, 100%)' }}>
                                                        {/* <DropDown onChangeSelect={(e) => {
                                                    // setSelectedProject(allProjects.filter((ele) => { return ele.projectName === e })[0]?.projectId)
                                                    setCurrentProjectForAll(e)
                                                    // }} list={allProjects} selectedValue={allProjects.filter((e) => { return e.projectId === selectedProject })[0]?.projectName} />
                                                }} list={[...['All'], ...projects]} selectedValue={currentProjectForAll} /> */}
                                                        <CustomAutoComplete NoOptionsText={'No project found'}
                                                            InitialValue={(e) => {
                                                                if (!e) {
                                                                    setCurrentProjectForAll('All')
                                                                } else {
                                                                    setCurrentProjectForAll(e)
                                                                }
                                                            }}
                                                            // list={[...['All'], ...projects]} multiple={false} disable={false}
                                                            list={projects} multiple={false} disable={false}
                                                            value={currentProjectForAll}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={cssClasses.tabsWrapper} style={{ height: "100%" }}>
                                                    <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
                                                        <TabContext value={subTabs.find(f => f.isSelected).value}>
                                                            <TabsMenu
                                                                selectedColor={"#1570EF"}
                                                                selectedBackgroundColor={"#FFFFFF"}
                                                                stylesForTab={{
                                                                    color: '#344054',
                                                                    fontSize: '1.6rem',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: '500',
                                                                    lineHeight: '2.4rem',
                                                                    padding: "0.8rem 1.2rem",
                                                                    textTransform: 'unset',
                                                                    borderBottom: "1px solid #EAECF0"
                                                                }}
                                                                borderColor={"#1570EFs"}
                                                                stylesForWrapper={{
                                                                    padding: "1.5rem 0",
                                                                    background: "#FFFFFF",
                                                                }}
                                                                list={subTabs}
                                                                value={subTabs.find(f => f.isSelected).value}
                                                                handleChange={(e, value) => {
                                                                    tabChange(e, value)
                                                                    setSubTabs((pre) => {
                                                                        pre.forEach((ele) => {
                                                                            if (ele.value === value) {
                                                                                ele.isSelected = true
                                                                            } else {
                                                                                ele.isSelected = false
                                                                            }
                                                                        })
                                                                        return [...pre]
                                                                    })
                                                                }}
                                                            />



                                                            <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"Overview"} index={2}>
                                                                <div className={cssClasses.totalCountsDiv}>
                                                                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 24 }}>
                                                                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs?.Leads?.['Projects']?.isAccessible &&
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard selectedProject={currentProjectForAll} icon={totalLeads} number={loggedInUser.roleId.level === 1 ? (allCounts?.totalleads + allCounts?.unclaimedleads) : allCounts?.totalleads} title={'Total Leads'} />
                                                                            </Grid>
                                                                        }
                                                                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs?.Leads?.['Nuturing']?.isAccessible &&
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard selectedProject={currentProjectForAll} icon={activeLeads} number={allCounts?.activeleads} title={'Active Leads'} />
                                                                            </Grid>
                                                                        }
                                                                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs?.Leads?.['Site Visit']?.isAccessible &&
                                                                            < Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard selectedProject={currentProjectForAll} icon={activeLeads} number={allCounts?.totalsitevisits} title={'Site Visits'} />
                                                                            </Grid>
                                                                        }
                                                                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs?.Leads?.['Token']?.isAccessible &&
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard showViewDetails={true} viewDetailsClicked={viewDetailsClicked} selectedProject={currentProjectForAll} icon={totalTokens} number={allCounts?.totaltokens} title={'Total Tokens'} />
                                                                            </Grid>
                                                                        }
                                                                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs?.Leads?.['Allotment']?.isAccessible &&
                                                                            <>
                                                                                <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                    <DashboardCard showViewDetails={true} viewDetailsClicked={viewDetailsClicked} selectedProject={currentProjectForAll} icon={totalAllotments} number={allCounts?.totalallotments} title={'Booking In Progress'} />
                                                                                </Grid>
                                                                                <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                    <DashboardCard showViewDetails={true} viewDetailsClicked={viewDetailsClicked} selectedProject={currentProjectForAll} icon={agreementDone} number={allCounts?.agreementdone} title={'Booking Done'} />
                                                                                </Grid>
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </div>
                                                                <div className={cssClasses.earningSummary}>
                                                                    <Card style={{ width: "100%", height: '35rem', padding: '2.4rem', flex: '50%' }}>
                                                                        <div className={cssClasses.headerDiv}>
                                                                            <p className={cssClasses.graphTitle}>Earnings Summary</p>
                                                                            <div>
                                                                                <DropDown list={yearList} selectedValue={currentYear} onChangeSelect={((e) => { setCurrentYear(e) })} />
                                                                            </div>
                                                                            <div>
                                                                                <DropDown list={['Total Sales Amount', 'Total Area Sold', 'Total Units Sold']} selectedValue={selectedGraph === 'totalsalesamount' ? 'Total Sales Amount' : selectedGraph === 'totalareasold' ? 'Total Area Sold' : 'Total Units Sold'} onChangeSelect={((e) => { setSelectedGraph(e.toLocaleLowerCase().replaceAll(' ', '')) })} />
                                                                            </div>
                                                                        </div>
                                                                        <Card style={{ boxShadow: 'unset', height: 'calc(100% - 3rem)', width: '100%' }}>
                                                                            <Bar style={{ width: "100% !important", height: '100% !important' }} options={options} data={{
                                                                                labels,
                                                                                datasets: [
                                                                                    {
                                                                                        label: selectedGraph === 'totalsalesamount' ? `Total Sales Amount in rs` : selectedGraph === 'totalareasold' ? 'Total Area Sold in sqft' : 'Total Units Sold',
                                                                                        data: allCounts?.[selectedGraph],
                                                                                        // data: [100, 200, 150, 300, 500, 150, 100, 200, 150, 300, 500, 150],
                                                                                        backgroundColor: selectedGraph === 'totalsalesamount' ? "#4ADE80" : selectedGraph === 'totalareasold' ? "#6366F1" : "#F87171"
                                                                                    }
                                                                                ]
                                                                            }} />
                                                                        </Card>
                                                                    </Card>
                                                                    <Card style={{ padding: '2.4rem', flex: '35%' }}>
                                                                        <div className={cssClasses.graphCountsDiv}>
                                                                            <div style={{ width: '5rem', height: '2rem', color: "#4ADE80", background: "#4ADE80" }}></div>
                                                                            <p>Total Sales Amount</p>
                                                                            <p>₹ {numDifferentiation(allCounts?.totalsalesamount.reduce(add, 0))}</p>
                                                                        </div>
                                                                        <div className={cssClasses.graphCountsDiv}>
                                                                            <div style={{ width: '5rem', height: '2rem', color: "#6366F1", background: "#6366F1" }}></div>
                                                                            <p>Total Area Sold</p>
                                                                            <p>{numberWithCommas(allCounts?.totalareasold.reduce(add, 0))} sqft.</p>
                                                                        </div>
                                                                        <div style={{ marginBottom: '0rem' }} className={cssClasses.graphCountsDiv}>
                                                                            <div style={{ width: '5rem', height: '2rem', color: "#F87171", background: "#F87171" }}></div>
                                                                            <p>Total Units Sold</p>
                                                                            <p>{numberWithCommas(allCounts?.totalunitssold.reduce(add, 0))}</p>
                                                                        </div>
                                                                    </Card>
                                                                </div>
                                                                <div className={cssClasses.performance}>
                                                                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
                                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                            <Card style={{ padding: '2.4rem' }} className={cssClasses.cardCss}>
                                                                                <div className={cssClasses.cardHeader1}>
                                                                                    <div style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '1rem'
                                                                                    }}>
                                                                                        <Project color={"#FFFF"} fill={"#1570EF"} />
                                                                                        <p>All Projects</p>
                                                                                    </div>
                                                                                    {/* <div>
                                                                <p className={cssClasses.button} onClick={() => setShowProjectWise(true)}>View Details</p>
                                                            </div> */}
                                                                                </div>
                                                                                <div className={cssClasses.projectsHeader}>
                                                                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                                                                    <p style={{ flex: '25%' }} className={cssClasses.projectFields}>Total Sales</p>
                                                                                    <p style={{ flex: '25%' }} className={cssClasses.projectFields}>Total Area Sold</p>
                                                                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Units Sold</p>
                                                                                    <p style={{ textAlign: 'center', flex: '10%' }} className={cssClasses.projectFields}></p>
                                                                                </div>
                                                                                {topProjects.map((m) => (
                                                                                    <div className={cssClasses.projectsHeader}>
                                                                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.projectname}</p>
                                                                                        <p style={{ flex: '25%' }} className={cssClasses.projectFields}>₹ {numDifferentiation(m.totalsalesamount)}</p>
                                                                                        <p style={{ flex: '25%' }} className={cssClasses.projectFields}>{m.totalareasold} sqft.</p>
                                                                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                                                        {/* <p style={{ textAlign: 'center', flex: '10%' }} className={cssClasses.button} onClick={() => { setSelectedProject(m.projectname) }}>Details</p> */}
                                                                                    </div>
                                                                                ))
                                                                                }
                                                                                {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                                                            </Card>
                                                                        </Grid>
                                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                            <Card style={{ padding: '2.4rem' }} className={cssClasses.cardCss}>
                                                                                <div className={cssClasses.cardHeader}>
                                                                                    <User color={"#FFFF"} fill={"#1570EF"} />
                                                                                    <p>Top Performing Sales Users</p>
                                                                                </div>
                                                                                <div className={cssClasses.projectsHeader}>
                                                                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                                                                    <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                                                                    <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Area Sold</p>
                                                                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Total Units Sold</p>
                                                                                </div>
                                                                                {topSales.map((m) => (
                                                                                    <div className={cssClasses.projectsHeader}>
                                                                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.salesname}</p>
                                                                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>₹ {numDifferentiation(m.totalsalesamount)}</p>
                                                                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>{m.totalareasold} sqft.</p>
                                                                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                                                    </div>
                                                                                ))
                                                                                }
                                                                                {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                                                            </Card>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            </TabPanel>
                                                            <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"Inventory"} index={2}>
                                                                <>
                                                                    {selectedProject &&
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'baseline',
                                                                            gap: '5rem',
                                                                            marginBottom: '2rem'
                                                                        }}>
                                                                            <p className={cssClasses.button} onClick={() => { setMode('all'); setSelectedProject('') }}>Back</p>
                                                                            <div style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '2rem',
                                                                                width: '100%',
                                                                                marginBottom: '2rem'
                                                                            }}>
                                                                                <p style={{ fontSize: '2rem' }}>Project :</p>
                                                                                <div style={{ width: 'min(250px,70%)' }}>
                                                                                    {/* <DropDown onChangeSelect={(e) => {
                                                    // setSelectedProject(allProjects.filter((ele) => { return ele.projectName === e })[0]?.projectId)
                                                    setCurrentProjectForAll(e)
                                                    // }} list={allProjects} selectedValue={allProjects.filter((e) => { return e.projectId === selectedProject })[0]?.projectName} />
                                                }} list={[...['All'], ...projects]} selectedValue={currentProjectForAll} /> */}
                                                                                    <CustomAutoComplete NoOptionsText={'No project found'}
                                                                                        InitialValue={(e) => {
                                                                                            if (!e) {
                                                                                                setSelectedProject(projects[0])
                                                                                            } else {
                                                                                                setSelectedProject(e)
                                                                                            }
                                                                                        }}
                                                                                        list={projects} multiple={false} disable={false}
                                                                                        value={selectedProject}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className={cssClasses.totalCountsDiv}>
                                                                        <p className={cssClasses.countsHeader}>Farvision</p>
                                                                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={totalLeads} number={projectCounts?.totalunits} title={'Total Units'} />
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={totalTokens} number={projectCounts?.farvisionavailable} title={'Farvision Available Units'} />
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={activeLeads} number={projectCounts?.farvisionbooked} title={'Farvision Booked Units'} />
                                                                            </Grid>
                                                                        </Grid>
                                                                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Selected Units</p>
                                                                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={totalLeads} number={projectCounts?.selectedunits} title={'Selected Units'} />
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={totalTokens} number={projectCounts?.availableunits} title={'Available Units'} />
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={totalAllotments} number={projectCounts?.bookinginprogressunits} title={'Booking In Progress'} />
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <DashboardCard icon={activeLeads} number={projectCounts?.bookedunits} title={'Booked Units'} />
                                                                            </Grid>
                                                                            {/* <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={agreementDone} number={allCounts?.agreementdone} title={'Agreement Done'} />
                            </Grid> */}
                                                                        </Grid>
                                                                    </div>
                                                                    <div className={cssClasses.earningSummary}>
                                                                        <Card style={{ width: "100%", height: '35rem', padding: '2.4rem', flex: '50%' }}>
                                                                            <div className={cssClasses.headerDiv}>
                                                                                <p className={cssClasses.graphTitle}>Monthly Units Sold</p>
                                                                                <div>
                                                                                    <DropDown list={yearList} selectedValue={currentYear} onChangeSelect={((e) => { setCurrentYear(e) })} />
                                                                                </div>
                                                                            </div>
                                                                            <Card style={{ boxShadow: 'unset', height: 'calc(100% - 3rem)', width: '100%' }}>
                                                                                <Bar style={{ width: "100% !important", height: '100% !important' }} options={options} data={{
                                                                                    labels,
                                                                                    datasets: unitSoldData
                                                                                }} />
                                                                            </Card>
                                                                        </Card>
                                                                        <Card style={{ padding: '2.4rem', flex: '35%', maxHeight: '350px', overflowY: 'auto' }}>
                                                                            {unitSoldData.map((m) => (
                                                                                <div className={cssClasses.graphCountsDiv}>
                                                                                    <div style={{ width: '5rem', height: '2rem', color: m.backgroundColor, background: m.backgroundColor }}></div>
                                                                                    <p>{m.label}</p>
                                                                                    <p>{m.data.reduce(add, 0)}</p>
                                                                                </div>
                                                                            ))
                                                                            }
                                                                        </Card>
                                                                    </div>
                                                                    <div className={cssClasses.performance}>
                                                                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                                                                    <div className={cssClasses.cardHeader}>
                                                                                        <Project color={"#FFFF"} fill={"#1570EF"} />
                                                                                        <p>Top Performing Cp's</p>
                                                                                    </div>
                                                                                    <div className={cssClasses.projectsHeader}>
                                                                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                                                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Units Sold</p>
                                                                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                                                                    </div>
                                                                                    {topCp.map((m) => (
                                                                                        <>
                                                                                            {m.cpname &&
                                                                                                < div className={cssClasses.projectsHeader} >
                                                                                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.cpname}</p>
                                                                                                    <p style={{ flex: '20%' }} className={cssClasses.projectFields}>₹ {numberWithCommas(m.totalamount)}</p>
                                                                                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                                                                </div>
                                                                                            }
                                                                                        </>
                                                                                    ))
                                                                                    }
                                                                                    {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                                                                </Card>
                                                                            </Grid>
                                                                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                                                <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                                                                    <div className={cssClasses.cardHeader}>
                                                                                        <User color={"#FFFF"} fill={"#1570EF"} />
                                                                                        <p>Top Performing Sales Users</p>
                                                                                    </div>
                                                                                    <div className={cssClasses.projectsHeader}>
                                                                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                                                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Units Sold</p>
                                                                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                                                                    </div>
                                                                                    {topSales.map((m) => (
                                                                                        <div className={cssClasses.projectsHeader}>
                                                                                            <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.salesname}</p>
                                                                                            <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                                                            <p style={{ flex: '20%' }} className={cssClasses.projectFields}>₹ {numberWithCommas(m.totalamount)}</p>
                                                                                        </div>
                                                                                    ))
                                                                                    }
                                                                                    {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                                                                </Card>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                </>
                                                            </TabPanel>
                                                            <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"Sales"} index={2}>
                                                                {salesUi()}
                                                            </TabPanel>
                                                        </TabContext>
                                                    </Box>
                                                </div>
                                            </>
                                        }
                                        {mode === 'booking in progress' &&
                                            <>
                                                {selectedProjectForBookingInProgress &&
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: '5rem',
                                                        marginBottom: '2rem'
                                                    }}>
                                                        <p className={cssClasses.button} onClick={() => { setMode('all'); setSelectedProjectForBookingInProgress('') }}>Back</p>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '2rem',
                                                            width: '100%',
                                                            marginBottom: '2rem'
                                                        }}>
                                                            <p style={{ fontSize: '2rem' }}>Project :</p>
                                                            <div style={{ width: 'min(250px,70%)' }}>
                                                                {/* <DropDown onChangeSelect={(e) => {
                                                    // setSelectedProject(allProjects.filter((ele) => { return ele.projectName === e })[0]?.projectId)
                                                    setCurrentProjectForAll(e)
                                                    // }} list={allProjects} selectedValue={allProjects.filter((e) => { return e.projectId === selectedProject })[0]?.projectName} />
                                                }} list={[...['All'], ...projects]} selectedValue={currentProjectForAll} /> */}
                                                                <CustomAutoComplete NoOptionsText={'No project found'}
                                                                    InitialValue={(e) => {
                                                                        if (!e) {
                                                                            setSelectedProjectForBookingInProgress('All')
                                                                        } else {
                                                                            // if (e === 'All') {
                                                                            //     setSelectedProjectForBookingInProgress(projects)
                                                                            // } else {
                                                                            setSelectedProjectForBookingInProgress(e)
                                                                            // }
                                                                        }
                                                                    }}
                                                                    list={["All", ...projects]} multiple={false} disable={false}
                                                                    value={selectedProjectForBookingInProgress}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className={cssClasses.totalCountsDiv}>
                                                    <p className={cssClasses.countsHeader}>Farvision</p>
                                                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 12 }}>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={totalLeads} number={bookingInProgressCounts?.totalallotments ?? 0} title={'Booking In Progress'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={totalTokens} number={bookingInProgressCounts?.onhold ?? 0} title={'On Hold'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={activeLeads} number={bookingInProgressCounts?.paymentpending ?? 0} title={'Payment Pending'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={totalLeads} number={bookingInProgressCounts?.preselected ?? 0} title={'Preselected'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={totalTokens} number={bookingInProgressCounts?.partialpaymentkycnotdone ?? 0} title={'Partial Payment Done & Kyc Pending'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={totalAllotments} number={bookingInProgressCounts?.partialpaymentkycdone ?? 0} title={'Partial Payment Done & Kyc Done'} />
                                                        </Grid>
                                                        <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                                            <DashboardCard icon={activeLeads} number={bookingInProgressCounts?.paymentcompletekycnotdone ?? 0} title={'Payment Complete & Kyc Pending'} />
                                                        </Grid>
                                                        {/* <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={agreementDone} number={allCounts?.agreementdone} title={'Agreement Done'} />
                            </Grid> */}
                                                    </Grid>
                                                </div>
                                            </>
                                        }
                                        {mode === 'unit analysis' &&
                                            <>
                                                {unitAnalysis()}
                                            </>
                                        }
                                        {mode === 'Total Tokens analysis' &&
                                            <>
                                                <TotalTokensAnalysis
                                                    goBack={() => {
                                                        setMode('all');
                                                        setSelectedProject('');
                                                    }}
                                                />
                                            </>
                                        }
                                    </TabPanel>
                                    <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"CP"} index={1}>
                                        {cpUi()}
                                    </TabPanel>
                                    <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"Sales"} index={2}>
                                        {salesUi()}
                                    </TabPanel>
                                    <TabPanel style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }} className={cssClasses.Tabs} value={"Events"} index={3}>
                                        <EventsDashboard isShowEventDropdown={true} />
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </div>
                    </div>
                </>
            }
            {mode === 'project wise' &&
                <>
                    {selectedProject &&
                        <div style={{
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: '5rem',
                            marginBottom: '2rem'
                        }}>
                            <p className={cssClasses.button} onClick={() => { setMode('all'); setSelectedProject('') }}>Back</p>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2rem',
                                width: '100%',
                                marginBottom: '2rem'
                            }}>
                                <p style={{ fontSize: '2rem' }}>Project :</p>
                                <div style={{ width: 'min(250px,70%)' }}>
                                    {/* <DropDown onChangeSelect={(e) => {
                                                    // setSelectedProject(allProjects.filter((ele) => { return ele.projectName === e })[0]?.projectId)
                                                    setCurrentProjectForAll(e)
                                                    // }} list={allProjects} selectedValue={allProjects.filter((e) => { return e.projectId === selectedProject })[0]?.projectName} />
                                                }} list={[...['All'], ...projects]} selectedValue={currentProjectForAll} /> */}
                                    <CustomAutoComplete NoOptionsText={'No project found'}
                                        InitialValue={(e) => {
                                            if (!e) {
                                                setSelectedProject(projects[0])
                                            } else {
                                                setSelectedProject(e)
                                            }
                                        }}
                                        list={projects} multiple={false} disable={false}
                                        value={selectedProject}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    <div className={cssClasses.totalCountsDiv}>
                        <p className={cssClasses.countsHeader}>Farvision</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={totalLeads} number={projectCounts?.totalunits} title={'Total Units'} />
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={totalTokens} number={projectCounts?.farvisionavailable} title={'Farvision Available Units'} />
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={activeLeads} number={projectCounts?.farvisionbooked} title={'Farvision Booked Units'} />
                            </Grid>
                        </Grid>
                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Selected Units</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={totalLeads} number={projectCounts?.selectedunits} title={'Selected Units'} />
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={totalTokens} number={projectCounts?.availableunits} title={'Available Units'} />
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={totalAllotments} number={projectCounts?.bookinginprogressunits} title={'Booking In Progress'} />
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={activeLeads} number={projectCounts?.bookedunits} title={'Booked Units'} />
                            </Grid>
                            {/* <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <DashboardCard icon={agreementDone} number={allCounts?.agreementdone} title={'Agreement Done'} />
                            </Grid> */}
                        </Grid>
                    </div>
                    <div className={cssClasses.earningSummary}>
                        <Card style={{ width: "100%", height: '35rem', padding: '2.4rem', flex: '50%' }}>
                            <div className={cssClasses.headerDiv}>
                                <p className={cssClasses.graphTitle}>Monthly Units Sold</p>
                                <div>
                                    <DropDown list={yearList} selectedValue={currentYear} onChangeSelect={((e) => { setCurrentYear(e) })} />
                                </div>
                            </div>
                            <Card style={{ boxShadow: 'unset', height: 'calc(100% - 3rem)', width: '100%' }}>
                                <Bar style={{ width: "100% !important", height: '100% !important' }} options={options} data={{
                                    labels,
                                    datasets: unitSoldData
                                }} />
                            </Card>
                        </Card>
                        <Card style={{ padding: '2.4rem', flex: '35%', maxHeight: '350px', overflowY: 'auto' }}>
                            {unitSoldData.map((m) => (
                                <div className={cssClasses.graphCountsDiv}>
                                    <div style={{ width: '5rem', height: '2rem', color: m.backgroundColor, background: m.backgroundColor }}></div>
                                    <p>{m.label}</p>
                                    <p>{m.data.reduce(add, 0)}</p>
                                </div>
                            ))
                            }
                        </Card>
                    </div>
                    <div className={cssClasses.performance}>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                    <div className={cssClasses.cardHeader}>
                                        <Project color={"#FFFF"} fill={"#1570EF"} />
                                        <p>Top Performing Cp's</p>
                                    </div>
                                    <div className={cssClasses.projectsHeader}>
                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Units Sold</p>
                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                    </div>
                                    {topCp.map((m) => (
                                        <>
                                            {m.cpname &&
                                                < div className={cssClasses.projectsHeader} >
                                                    <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.cpname}</p>
                                                    <p style={{ flex: '20%' }} className={cssClasses.projectFields}>₹ {numberWithCommas(m.totalamount)}</p>
                                                    <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                                </div>
                                            }
                                        </>
                                    ))
                                    }
                                    {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                </Card>
                            </Grid>
                            <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                <Card style={{ padding: '2.4rem', maxHeight: '350px', overflowY: 'auto' }}>
                                    <div className={cssClasses.cardHeader}>
                                        <User color={"#FFFF"} fill={"#1570EF"} />
                                        <p>Top Performing Sales Users</p>
                                    </div>
                                    <div className={cssClasses.projectsHeader}>
                                        <p style={{ flex: '40%' }} className={cssClasses.projectFields}>Name</p>
                                        <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>Units Sold</p>
                                        <p style={{ flex: '20%' }} className={cssClasses.projectFields}>Total Sales</p>
                                    </div>
                                    {topSales.map((m) => (
                                        <div className={cssClasses.projectsHeader}>
                                            <p style={{ flex: '40%' }} className={cssClasses.projectFields}>{m.salesname}</p>
                                            <p style={{ textAlign: 'center', flex: '20%' }} className={cssClasses.projectFields}>{m.totalunitssold}</p>
                                            <p style={{ flex: '20%' }} className={cssClasses.projectFields}>₹ {numberWithCommas(m.totalamount)}</p>
                                        </div>
                                    ))
                                    }
                                    {/* <Datagrid hideFooter={true} columns={projectColumns} rows={topProjects} /> */}
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </>
            }
        </div >
    )
}
